import { Button } from "@devhop/ui";
import { HelpCircle, PlusIcon } from "lucide-react";

type QCRecordToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function QCRecordToolbar({
  canManage,
  onCreate,
  onStartTour,
}: QCRecordToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">ລາຍການບັນທຶກ QC</h2>
            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={onStartTour}
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground">
            ຈັດການບັນທຶກຜົນການກວດສອບ QC (QC Records).
          </p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <div data-tourid="record-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງບັນທຶກ QC ໃໝ່
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
